interface StableIconProps {
  className?: string
}

export function StableIcon({ className }: StableIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1017 1017"
      fill="none"
      className={className}
    >
      <circle cx="508.5" cy="508.5" r="508.5" fill="url(#paint0_linear_1135_2436)" />
      <g clipPath="url(#clip0_1135_2436)">
        <path
          d="M508.501 545.71C541.516 525.695 588.602 498.001 625.625 498.001C684.878 498.001 734.421 539.951 734.421 619.646C734.421 746.781 583.281 863.994 369.712 812.939C369.006 812.77 368.315 813.306 368.315 814.026V871.193V878.152V882.753C368.315 883.219 368.597 883.628 369.034 883.798C398.478 894.808 429.572 902.444 461.838 906.227C712.063 935.643 928.258 726.921 907.636 475.812C901.722 403.81 877.36 337.596 838.093 281.587C837.797 281.163 837.274 280.895 836.54 281.276L508.699 470.773C471.436 492.03 428.584 518.623 391.632 518.623C332.379 518.623 282.836 476.673 282.836 396.978C282.836 269.829 433.99 152.63 647.559 203.699C648.265 203.868 648.942 203.346 648.942 202.612V134.944C648.942 134.478 648.66 134.055 648.223 133.899C604.848 117.808 557.959 109 508.995 109C288.087 109 109 288.08 109 508.997C109 592.799 134.788 670.573 178.839 734.84C179.178 735.32 179.827 735.475 180.336 735.179L508.501 545.71Z"
          fill="#E8FBF7"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1135_2436"
          x1="508.5"
          y1="0"
          x2="508.5"
          y2="1017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01201E" />
          <stop offset="1" stopColor="#033528" />
        </linearGradient>
        <clipPath id="clip0_1135_2436">
          <rect width="800" height="800" fill="white" transform="translate(109 109)" />
        </clipPath>
      </defs>
    </svg>
  )
}
